import script from "./AdminPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPopup.vue?vue&type=script&setup=true&lang=js"

import "./AdminPopup.vue?vue&type=style&index=0&id=66fc29f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66fc29f6"]])

export default __exports__